import React from "react";
import { Dialog } from "@headlessui/react";
import Table from "../../Table";
import FileInput from "../../FileInput";

const columns = [
    { name: "uploadDate", displayText: "Fecha" },
    { name: "name", displayText: "Nombre del archivo", truncate: true },
];

export default function ConsultationDocumentsModalContent({
    documents,
    patientDocument,
    setPatientDocument,
    handleFileSelect,
    onClose,
}) {
    return (
        <div>
            <div className="max-h-[90dvh] overflow-x-hidden overflow-y-auto">
                <div className="flex flex-col gap-6 text-center">
                    <Dialog.Title
                        as="h3"
                        className="text-xl font-semibold leading-6 text-gray-900 dark:text-white"
                    >
                        Documentos
                    </Dialog.Title>
                    <div className="text-left">
                        {documents.length > 0 ? (
                            <Table
                                actiontext="Ver"
                                setSelectedDocument={patientDocument}
                                document={true}
                                columns={columns}
                                rows={documents}
                            />
                        ) : (
                            <p className="text-center">No se han encontrado documentos</p>
                        )}
                    </div>
                    <div>
                        <FileInput
                            multiple={true}
                            labelClassName="text-sm font-medium leading-[20px] text-[#374151] dark:text-gray-200"
                            buttonText="Adjuntar archivo"
                            handleChange={(name, files) => handleFileSelect(files)}
                            name="document"
                        />
                        <div className="mt-2 grid grid-cols-1 gap-2 text-black md:grid-cols-2">
                            {patientDocument.documents.map((doc, index) => (
                                <div key={index} className="mb-2 flex items-center gap-2">
                                    <input
                                        type="text"
                                        value={doc.name}
                                        onChange={(e) => {
                                            const updated = [...patientDocument.documents];
                                            updated[index].name = e.target.value;
                                            setPatientDocument({
                                                ...patientDocument,
                                                documents: updated,
                                            });
                                        }}
                                        className="rounded border p-1"
                                    />
                                    <span className="text-sm text-gray-500">.{doc.extension}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="flex flex-col gap-1">
                        <button
                            type="button"
                            onClick={() => setPatientDocument({ documents: [] })}
                            className="flex h-fit justify-center gap-2 rounded-md border border-primary bg-transparent px-4 py-2 text-sm font-medium text-primary shadow-sm"
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            className="inline-flex w-full justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-primary sm:text-sm"
                            onClick={onClose}
                        >
                            Continuar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
